import _BaseAPIService from "../_BaseAPIService";

const instance = _BaseAPIService.instance;

const AccountingReportService = {
  // GET /api/accounting/reports/ledger-statement
  getLedgerStatement: async ({ ledgerId, from, to, fiscalYearCode }) => {
    try {
      const response = await instance.get("/accounting/reports/ledger-statement", {
        params: { ledgerId, from, to, fiscalYearCode },
        headers: {
          Authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching ledger statement:", error);
      throw error;
    }
  },

  // GET /api/accounting/reports/trial-balance
  getTrialBalance: async ({ fiscalYearCode, to }) => {
    try {
      const response = await instance.get("/accounting/reports/trial-balance", {
        params: { fiscalYearCode, to },
        headers: {
          Authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching trial balance:", error);
      throw error;
    }
  },

  // GET /api/accounting/reports/balance-sheet
  getBalanceSheet: async ({ fiscalYearCode, asOf }) => {
    try {
      const response = await instance.get("/accounting/reports/balance-sheet", {
        params: { fiscalYearCode, asOf },
        headers: {
          Authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching balance sheet:", error);
      throw error;
    }
  },

  // Legacy endpoints (kept for backward compatibility)
  BalanceSheet: async () => {
    try {
      const response = await instance.get(
        "/AccountReporting/GetBalanceSheetList"
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  ProfitLoss: async () => {
    try {
      const response = await instance.get("/AccountReporting/GetPLSheetList");
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default AccountingReportService;
